// 자금계획 등록 폼 공용 상수 — FinanceEntryModal · CashFlowTab 이 공유(중복 정의 제거).
// 여기 한 곳만 고치면 두 화면의 카테고리 후보·결제 유형이 함께 갱신된다.
// (기존엔 두 파일에 같은 배열이 복제돼, 한 곳에만 카테고리를 추가하면 다른 화면 드롭다운엔 안 떠 오타 유입 위험이 있었다.)
export const CATEGORY_SUGGESTIONS = ["프로젝트", "사업소득", "고정비/관리비", "물품구매", "프로젝트 제외", "계약금", "잔금", "미수금"];
export const PAYMENT_TYPES = ["일반", "고정비"];
